import { render, staticRenderFns } from "./contentLectureYoutube.vue?vue&type=template&id=3d228d4c&"
import script from "./contentLectureYoutube.vue?vue&type=script&lang=js&"
export * from "./contentLectureYoutube.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports